import React from 'react'
import { Button, Input, Card } from 'antd'
import { Play as PlayIcon } from '@styled-icons/bootstrap/Play'
import { QrCodeFormData, QrCodeState } from 'Types/QrCode.d'

interface SheetDataFormProps {
  formData: QrCodeFormData
  state: QrCodeState
  onFormDataChange: (updates: Partial<QrCodeFormData>) => void
  onFetchSheetData: () => void
}

const SheetDataForm: React.FC<SheetDataFormProps> = ({
  formData,
  state,
  onFormDataChange,
  onFetchSheetData
}) => {
  return (
    <Card 
      title={<span className="text-lg font-semibold">Step 1: Input Google Sheet URL</span>} 
      bordered={false} 
      className="shadow-md hover:shadow-lg transition-shadow"
    >
      <div className="p-4 w-full">
        <div className="flex flex-col gap-4">
          <div>
            <label className="text-sm font-medium text-gray-700 block mb-1">Google Sheet URL</label>
            <Input 
              placeholder="Enter Google Sheet URL" 
              value={formData.google_sheet_url} 
              onChange={(e) => onFormDataChange({ google_sheet_url: e.target.value })} 
              disabled={state.loading}
              className="border-2 focus:border-blue-400"
            />
          </div>
          
          <div>
            <label className="text-sm font-medium text-gray-700 block mb-1">Tab Name (Optional)</label>
            <Input 
              placeholder="Enter tab name (e.g. 'Link sp dùng để gen QR code')" 
              value={formData.tabName} 
              onChange={(e) => onFormDataChange({ tabName: e.target.value })} 
              disabled={state.loading}
              className="border-2 focus:border-blue-400"
            />
          </div>
          
          <Button
            loading={state.loading}
            disabled={!formData.google_sheet_url || state.loading}
            type="primary"
            className="font-semibold bg-blue-500 hover:bg-blue-600"
            onClick={onFetchSheetData}
            size="large"
          >
            <PlayIcon className="mr-2" style={{ width: 22, height: 22 }} />
            Load Sheet Data
          </Button>
          
          {state.error && (
            <div className="text-red-500 text-sm mt-2 p-2 bg-red-50 rounded border border-red-200">
              {state.error}
            </div>
          )}
        </div>
      </div>
    </Card>
  )
}

export default SheetDataForm 